import React from "react";

const Next = () => (
  <svg
    className="next-icon"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 96 120"
    x="0px"
    y="0px"
  >
    <title>arrowsArtboard 81</title>
    <path d="M33.65,77.35a.5.5,0,0,0,.71,0l29-29a.5.5,0,0,0,0-.71l-29-29a.5.5,0,0,0-.71.71L62.29,48,33.65,76.65A.5.5,0,0,0,33.65,77.35Z" />
  </svg>
);

const Prev = () => (
  <svg
    className="prev-icon"
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 96 120"
    x="0px"
    y="0px"
  >
    <title>arrowsArtboard 86</title>
    <path d="M62.65,77.35a.5.5,0,1,0,.71-.71L34.71,48,63.35,19.35a.5.5,0,1,0-.71-.71l-29,29a.5.5,0,0,0,0,.71Z" />
  </svg>
);

export { Next, Prev };
